import config from '../EnvConfig';

export const BASE_DOMAIN_URL = config.CRM_API_BASE_URL;
export const BASE_URL = `${config.CRM_API_BASE_URL}/api/v1`;
export const ERP_BASE_URL = config.ERP_BASE_URL;
export const ECONOMIC_APP_SECRET = config.ECONOMIC_APP_SECRET_TOKEN;
export const ECONOMIC_AGREEMENT_TOKEN = config.ECONOMIC_APP_AGREEMENT_TOKEN;
export const APP_BAR_COLOR_CODE = config.APP_BAR_COLOR_CODE;

// Initialize global timer variable for 10 hours auto logout
export const user_logout = {
    timer: null,
    time: 10, // It accepts hours
};

export const setRequestHeaders = () => {
    const defaultHeaders = {
        "Accept": "application/json, text/plain, */*",
        "Content-Type": "application/json",
    };

    if (localStorage.getItem("token") !== null) {
        defaultHeaders["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    }

    return defaultHeaders;
};

export const fetchGet = async (url, retries = 0, options = {}) => {
    for (let attempt = 0; attempt <= retries; attempt++) {
        try {
            const response = await fetch(BASE_URL + url, {
                method: "GET",
                headers: setRequestHeaders(),
            });

            // If raw is set, return blob directly
            if (options.raw) {
                return await response.blob();
            }

            return await handleResponse(response);
        } catch (error) {
            if (attempt < retries) continue;

            if (error?.code === 401) {
                const promise = new Promise((resolve, reject) => {
                    localStorage.removeItem("token");

                    if (!localStorage.getItem("token")) {
                        resolve("Redirecting you to the login screen. Please wait...");
                    } else {
                        reject(Error("Something went wrong while deleting user token"));
                    }
                });
                promise.then(
                    (_message) => {
                        window.location.href = "/";
                    },
                    (_error) => {
                    }
                );
            } else {
                throw new Error(error);
            }
        }
    }
};

export const fetchDelete = async (url) => {
    return fetch(BASE_URL + url, {
        method: "DELETE",
        headers: setRequestHeaders(),
    })
        .then(handleResponse)
        .then((response) => {
            return response;
        });
};

export const fetchPost = async (url, bodyObject, formData = false) => {
    if (formData) {
        return fetch(BASE_URL + url, {
            method: "POST",
            headers: setRequestHeaders(),
            body: bodyObject,
        })
            .then(handleResponse)
            .then((response) => {
                return response;
            });
    }

    return fetch(BASE_URL + url, {
        method: "POST",
        headers: setRequestHeaders(),
        body: JSON.stringify(bodyObject),
    })
        .then(handleResponse)
        .then((response) => {
            return response;
        });
};

export const fetchPatch = async (url, bodyObject) => {
    return fetch(BASE_URL + url, {
        method: "PATCH",
        headers: setRequestHeaders(),
        body: JSON.stringify(bodyObject),
    })
        .then(handleResponse)
        .then((response) => {
            return response;
        });
};

export const fetchPut = async (url, bodyObject) => {
    return fetch(BASE_URL + url, {
        method: "PUT",
        headers: setRequestHeaders(),
        body: JSON.stringify(bodyObject),
    })
        .then(handleResponse)
        .then((response) => {
            return response;
        });
};

export const fetchPostWithoutBody = async (url) => {
    return fetch(BASE_URL + url, {
        method: "POST",
        headers: setRequestHeaders(),
    })
        .then(handleResponse)
        .then((response) => {
            return response;
        });
};

const handleResponse = (response) => {
    if (!response.ok) {
        return response
            .text()
            .then((result) => JSON.parse(result))
            .then((result) =>
                Promise.reject({
                    code: result.error_code,
                    message: result.error,
                })
            );
    }

    return response
        .json()
        .then((result) => Promise.resolve(result))
        .catch(() =>
            Promise.resolve({
                status: response.status,
                message: response.statusText,
            })
        );
};

export const postFormData = async (url, bodyObject) => {
    return fetch(BASE_URL + url, {
        method: "POST",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: bodyObject,
    })
        .then(handleResponse)
        .then((response) => {
            return response;
        });
};

export const postFormMultiMediaData = async (url, formData) => {
    return fetch(BASE_URL + url, {
        method: "POST",
        // Do NOT set "Content-Type" here — the browser will add multipart/form-data; boundary=...
        headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            Accept: "application/json",
        },
        body: formData,           // if you need cookies
    }).then(handleResponse);
};
